import { render, staticRenderFns } from "./PowerSocketTable.vue?vue&type=template&id=048e26a4"
import script from "./PowerSocketTable.vue?vue&type=script&lang=js"
export * from "./PowerSocketTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports